"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stanford_svg_1 = __importDefault(require("@ClientAssets/icons/features/stanford.svg"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var Masthead_1 = __importDefault(require("../Masthead/Masthead"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var StanfordLogin = (0, mobx_react_1.observer)(function (props) { return (react_1.default.createElement("div", { className: "stanford-login" },
    react_1.default.createElement(Masthead_1.default, { explainer: "Welcome back" },
        react_1.default.createElement("div", { className: "masthead__sso" },
            react_1.default.createElement(kaleidoscope_1.Button, { className: "button__stanford", openInSameTab: true, href: function () { return "".concat(props.publicApiBaseUrl, "/auth/saml-stanford"); } },
                react_1.default.createElement(kaleidoscope_2.SVG, { className: "large", src: stanford_svg_1.default }),
                "Continue with SSO"))))); });
exports.default = StanfordLogin;
